import React, { useEffect, useRef, useState } from "react";

const MultiSelect = ({
  options,
  placeholder,
  alwaysShowPlaceholder = false,
  defaultOpt = [],
  searchable,
  defaultMenuIsOpen = false,
  defaultInputValue = "",
}) => {
  const [selectedOptions, setSelectedOptions] = useState(defaultOpt);
  const [searchTerm, setSearchTerm] = useState(defaultInputValue);
  const [isOpen, setIsOpen] = useState(defaultMenuIsOpen);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const inputRef = useRef(null);
  const optionRef = useRef(null);

  const handleToggleOption = (option) => {
    const isSelected = selectedOptions.some(
      (selected) => selected.value === option.value
    );
    setSearchTerm("");

    if (isSelected) {
      setSelectedOptions(
        selectedOptions.filter((selected) => selected.value !== option.value)
      );
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const clearOption = () => {
    setSearchTerm("");
    setSelectedOptions([]);
  };

  const selectAll = () => {
    setSelectedOptions([...options]);
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      const newIndex =
        e.key === "ArrowDown" ? highlightedIndex + 1 : highlightedIndex - 1;
      const newHighlightedIndex = Math.max(
        0,
        Math.min(newIndex, filteredOptions.length - 1)
      );
      setHighlightedIndex(newHighlightedIndex);
      setIsOpen(true);

      // Scroll the dropdown to make the highlighted option visible
      const list = document.getElementById("option-list");
      if (list) {
        const listItem = list.children[newHighlightedIndex];
        if (listItem) {
          listItem.scrollIntoView({ block: "nearest" });
        }
      }
    } else if (e.key === "Enter") {
      handleToggleOption(filteredOptions[highlightedIndex]);
    } else if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  const outsideClickHandler = (e) => {
    if(optionRef && !optionRef.current.contains(e.target) && !inputRef.current.contains(e.target)){
      setIsOpen(false)
    }
  }

  const removeItem = (item) => {
    setSelectedOptions((prev) =>
      prev.filter((option) => option.label !== item.label)
    );
    // setSelectedOptions(selectedOptions.filter((option) => option.value !== item.value));
  };

  useEffect(() => {
    document.addEventListener('mousedown', outsideClickHandler)

    return () => {
    document.removeEventListener('mousedown', outsideClickHandler)

    }
  })

  useEffect(() => {
    setHighlightedIndex(0);
    // if (isOpen && inputRef.current) {
    //   inputRef.current.focus();
    // }
  }, [isOpen]);

  return (
    <div
      className="border border-gray-400 relative w-80 min-h-10 flex items-center gap-2 p-2 rounded outline-none cursor-text focus:border-blue-400"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className="flex flex-wrap items-center gap-2 w-full">
        {selectedOptions &&
          selectedOptions.map((item) => {
            return (
              <button
                key={item.value}
                className="flex items-center border bg-gray-100 border-gray-200 rounded-2xl px-1 gap-1 justify-center outline-none hover:bg-red-200 hover:border-red-400 hover:text-red-500"
              >
                {item.label}{" "}
                <span
                  className="bg-transparent border-none outline-none cursor-pointer p-0 text-lg text-red-400"
                  onClick={() => removeItem(item)}
                >
                  &times;
                </span>
              </button>
            );
          })}
        {
          <input
            type="text"
            placeholder={
              selectedOptions.length > 0
                ? alwaysShowPlaceholder
                  ? placeholder
                  : ""
                : placeholder
            }
            ref={inputRef}
            className="outline-none min-w-5 text-base w-full"
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={() => setIsOpen((prev) => !prev)}
            value={searchTerm}
          />
        }
      </div>
      <button
        className="bg-transparent text-gray-500 border-none outline-none cursor-pointer p-0 text-xl focus:text-gray-700 hover:text-gray-700"
        onClick={(e) => {
          e.stopPropagation();
          clearOption();
        }}
      >
        &times;
      </button>
      <div className="bg-gray-500 self-stretch w-[0.05em]"></div>
      <button
        className="bg-transparent text-gray-500 border-none outline-none cursor-pointer p-0 text-base focus:text-gray-700 hover:text-gray-700"
        onClick={selectAll}
      >
        &#10003;
      </button>
      <ul
      ref={optionRef}
        id="option-list"
        className={`absolute m-0 p-0 list-none max-h-60 overflow-y-auto border border-gray-400 rounded w-full left-0 top-full mt-1 bg-white z-50 ${
          isOpen ? "" : "hidden"
        }`}
      >
        {filteredOptions.map((option, index) => (
          <li
            key={option.value}
            onClick={() => handleToggleOption(option)}
            className={`m-2 p-2 rounded cursor-pointer ${
              selectedOptions.some(
                (selected) => selected.value === option.value
              )
                ? "bg-blue-400 text-white"
                : ""
            } ${highlightedIndex === index ? "bg-blue-500 text-white" : ""}`}
            onMouseEnter={() => setHighlightedIndex(index)}
          >
            {/* {console.log(selectedOptions.some((selected) => selected.value === option.value))} */}
            {option.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MultiSelect;
